import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DestinationCard = ({ destination, onClick }) => {
  return (
    <div
      className="group bg-card rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-border cursor-pointer flex flex-col"
      onClick={onClick}
    >
      {/* Image Container */}
      <div className="relative h-32 md:h-44 lg:h-48 overflow-hidden flex-shrink-0">
        <Image
          src={destination?.image}
          alt={destination?.imageAlt}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        
        {/* Badges */}
        <div className="absolute top-1.5 left-1.5 flex flex-wrap gap-0.5">
          {destination?.isHiddenGem && (
            <div className="flex items-center gap-0.5 px-1 py-0.5 bg-accent/90 backdrop-blur-sm rounded-full">
              <Icon name="Sparkles" size={9} color="var(--color-accent-foreground)" />
              <span className="text-[7px] font-semibold text-accent-foreground">Hidden Gem</span>
            </div>
          )}
          {destination?.isFeatured && (
            <div className="flex items-center gap-0.5 px-1 py-0.5 bg-primary/90 backdrop-blur-sm rounded-full">
              <Icon name="Star" size={9} color="#FFFFFF" />
              <span className="text-[7px] font-semibold text-white">Featured</span>
            </div>
          )}
        </div>

        {/* Favorite Button */}
        <button className="absolute top-1.5 right-1.5 w-6 h-6 rounded-full bg-card/90 backdrop-blur-sm flex items-center justify-center hover:bg-card transition-all duration-300 shadow-lg">
          <Icon name="Heart" size={12} />
        </button>

        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
      </div>
      {/* Content */}
      <div className="p-2 md:p-3.5 lg:p-4 flex flex-col flex-1">
        <div className="flex items-start justify-between mb-1">
          <div className="flex-1 min-w-0">
            <h3 className="text-xs md:text-base font-semibold text-foreground mb-0.5 line-clamp-1 break-words">
              {destination?.name}
            </h3>
            <div className="flex items-center gap-0.5 text-[9px] md:text-xs text-muted-foreground">
              <Icon name="MapPin" size={9} />
              <span className="line-clamp-1 break-words">{destination?.location}</span>
            </div>
          </div>
        </div>

        <p className="text-[9px] md:text-xs text-muted-foreground mb-1.5 line-clamp-2 break-words">
          {destination?.description}
        </p>

        {/* Features */}
        <div className="flex flex-wrap gap-0.5 mb-1.5">
          {destination?.features?.slice(0, 3)?.map((feature, index) => (
            <div
              key={index}
              className="flex items-center gap-0.5 px-1 py-0.5 bg-muted rounded-lg"
            >
              <Icon name={feature?.icon} size={9} color="var(--color-primary)" />
              <span className="text-[7px] md:text-[9px] text-foreground break-words">{feature?.label}</span>
            </div>
          ))}
        </div>

        {/* Rating & Price */}
        <div className="flex items-center justify-between mb-1.5">
          <div className="flex items-center gap-0.5 flex-wrap">
            <Icon name="Star" size={10} color="var(--color-accent)" />
            <span className="text-[9px] md:text-xs font-semibold text-foreground">
              {destination?.rating}
            </span>
            <span className="text-[7px] md:text-[9px] text-muted-foreground">
              ({destination?.reviews} reviews)
            </span>
          </div>
          <div className="text-right">
            <p className="text-[7px] md:text-[9px] text-muted-foreground">Starting from</p>
            <p className="text-xs md:text-sm font-bold text-primary">₱{destination?.priceFrom?.toLocaleString()}</p>
          </div>
        </div>

        {/* Action Button */}
        <Button
          variant="default"
          size="default"
          fullWidth
          iconName="ArrowRight"
          iconPosition="right"
          className="text-[9px] md:text-sm py-1 md:py-1.5 mt-auto"
        >
          View Details
        </Button>
      </div>
    </div>
  );
};

export default DestinationCard;